import config from "@sg-protect/runtime-config";
import createFetchClient from "openapi-fetch";
import createQueryClient from "openapi-react-query";
import { Routes } from "../constants.ts";
import { redirectOnForbidden, redirectOnStatusCode } from "@sg-protect/core";
import { setMsalTokenMiddleware } from "./middlewares/setMsalToken.ts";
import type { AuthorizationFailureReasons, paths } from "./types.ts";

export interface QueryOptions {
    enabled?: boolean;
    retry?: boolean | number;
}

export const client = createFetchClient<paths>({
    baseUrl: config.get().insights.api,
    credentials: "include"
});

client.use(
    redirectOnStatusCode({
        status: 401,
        to: () => `${config.get().insights.login}?returnUrl=${encodeURIComponent(window.location.href)}`
    })
);

client.use(
    redirectOnForbidden<AuthorizationFailureReasons>({
        expectedFailureReason: "notConsented",
        to: Routes.microsoft.wizard
    })
);

client.use(
    redirectOnForbidden<AuthorizationFailureReasons>({
        expectedFailureReason: "invalidMsalToken",
        to: Routes.microsoft.wizard
    })
);

client.use(
    redirectOnForbidden<AuthorizationFailureReasons>({
        expectedFailureReason: "missingMsalUserRole",
        to: Routes.microsoft.wizard
    })
);

client.use(
    redirectOnForbidden<AuthorizationFailureReasons>({
        expectedFailureReason: "missingShareGateLicense",
        to: Routes.missingSharegateLicense
    })
);

if (process.env.APP_ENV !== "msw") {
    client.use(
        setMsalTokenMiddleware({
            headerName: "TenantAssessmentJwt"
        })
    );
}

export const { queryOptions, useMutation, useQuery, useSuspenseQuery } = createQueryClient(client);
